<template>
    <div class="bg-cover px-6 flex" :class="`fade-${backgroundColor}`">
        <div class="flex flex-col lg-down:flex-1 lg:flex-50 justify-center" :class="{
            'items-center': hasImage || !hasFeatures,
            'items-start': !hasImage && hasFeatures,
            'justify-center': hasImage,
            'justify-between': !hasImage
        }">

            <div class="ds-text-3xl text-white font-bold mb-4 mt-6 lg:mt-8 text-center">
                {{headerText}}
            </div>

            <img v-if="hasImage" :src="imageUrl" class="w-12 mb-4">

            <FeatureList v-if="hasFeatures" :features="features" class="lg:hidden mb-1 mt-1" />

            <Button class="mt-4 mb-4 lg:mb-6" :text="buttonText" @click="onButtonClick()" />
        </div>

        <div v-if="hasFeatures" class="lg-down:hidden border-0 border-l border-white border-solid pl-4 ml-4 my-6 flex-50">
            <FeatureList :features="features" />
        </div>
    </div>
</template>
<script>
    import { Button } from '@sportsrecruits/playbook'
    import FeatureList from './FeatureList'
    import track from '@/utils/segment'
    import api from '@/services/api'

    export default {
        components: {
            Button,
            FeatureList,
        },

        props: {
            headerText: { type: String, required: true },
            buttonText: { type: String, required: true },
            imageUrl: { type: String, required: false },
            actionUrl: { type: String, required: true },
            features: { type: Array, default: () => [] },
            backgroundColor: { type: String, required: true },
            trackedCta: { type: Object, required: true },
        },

        computed: {
            hasImage() {
                return !!this.imageUrl
            },

            hasFeatures() {
                return this.features.length > 0
            },
        },

        methods: {
            onButtonClick() {
                this.trackClick()

                window.location.href = this.actionUrl
            },

            trackClick() {
                if (this.trackedCta) {
                    track(this.trackedCta.type, {
                        site_access_id: api.clientData('site_access_id'),
                        page: window.location.href,
                        action: 'click',
                        cta_page: 'activity',
                        cta_name: this.trackedCta.name,
                    })
                }
            },
        },
    }
</script>
<style scoped lang="scss">
    $background-image: url(https://cdn.sportsrecruits.com/assets/Athlete-commit/college_logosBG.jpg);

    .fade-brown {
        background: linear-gradient(to right, rgba(25, 25, 30, .9) 0%), $background-image;
    }

    .fade-blue {
        background: linear-gradient(to right, rgba(20, 45, 85, .9) 0%), $background-image;
    }
</style>